// TODO EVR-2693 - Update these to use actual numbers instead of strings.
const AMORTIZATION_TERM_OPTIONS = [ 5, 10, 15, 20, 25, 30 ];

// A lot of components are starting to switch to this - need to confirm with mortgages team
// If they can also use. In the meantime keeping the above definition to not break
// existing usages
export const AMORTIZATION_OPTIONS_EXTENDED = [ ...Array(30).keys() ]
    .reverse()
    .map(i => i + 1);

export default AMORTIZATION_TERM_OPTIONS;